import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import ItemCard from '../../molecules/Result/ItemCard'
import classNames from 'classnames'

import CancelIcon from '../../../assets/icons/cancel_icon.svg'
import Text from '../../atoms/Text'

const AllFoodItemListing = forwardRef(({ foodItems, onClickItem }, ref) => {
  const [isOpen, setIsOpen] = useState(false)
  const divRef = useRef(null)
  useImperativeHandle(ref, () => ({
    show: () => setIsOpen(true),
    hide: () => setIsOpen(false),
  }))
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        divRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
      }, 100)
    }
  }, [isOpen])
  if (!foodItems) return null
  return (
    <div
      ref={divRef}
      className={classNames(
        `transition-all duration-700 transform  fixed top-0 left-0 right-0 h-screen overflow-y-scroll max-w-lg lg:max-w-6xl mx-auto bg-white`,
        isOpen ? 'translate-y-0 z-[999]' : 'translate-y-[100%] z-[0]',
      )}
    >
      <div>
        <div className="pt-2 w-full relative">
          <div
            className="absolute right-5 p-2 rounded-full shadow-xl w-9 h-9 flex items-center justify-start "
            onClick={() => setIsOpen(false)}
          >
            <img src={CancelIcon} />
          </div>
        </div>
        <div className="p-4 mt-4">
          <Text variant="headline" size="large">
            All items in your meal
          </Text>
        </div>
        <div className="flex flex-col p-4 gap-4">
          {(foodItems ?? []).map((foodItem) => (
            <ItemCard
              grade={foodItem.grade}
              isClickable
              onClick={() => onClickItem(foodItem)}
              showRecommendation
              title={foodItem.food_details.food_item}
              foodDetails={foodItem.food_details}
              keyNutrients={foodItem.key_nutrients}
            />
          ))}
        </div>
      </div>
    </div>
  )
})

export default AllFoodItemListing
